import React, { createContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const FreshworksContext = createContext(null);

const FreshworksProvider = ({ children }) => {
  const location = useLocation();
  const adminRoutes = [
  "/",
  "/dashboard",
  "/consultant-list",
  "/history",
  "/wallet-management",
  "/withdrawal-request",
  "/trial-upgrade",
  "/consultant-support",
  "/account-information",
  "/voucher-management",
  "/admin-percentage",
  "/revenue-management",
  "/faq",
  "/app-users",
];

const isAdminRoute = adminRoutes.includes(location.pathname);


  useEffect(() => {
    if (!isAdminRoute) return;

    window.fwSettings = {
      widget_id: 35000001127,
    };

    if (typeof window.FreshworksWidget !== "function") {
      const n = function () {
        n.q.push(arguments);
      };

      n.q = [];
      window.FreshworksWidget = n;
    }

    if (!document.getElementById("freshworks-widget-script")) {
      const script = document.createElement("script");

      script.id = "freshworks-widget-script";
      script.src =
        "https://widget.freshworks.com/widgets/35000001127.js";
      script.async = true;
      script.defer = true;

      document.body.appendChild(script);
    }
  }, [isAdminRoute]);

  return (
    <FreshworksContext.Provider value={{ isAdminRoute }}>
      {children}
    </FreshworksContext.Provider>
  );
};

export default FreshworksProvider;